import React, { useEffect, useState } from 'react';
import './page.css';
import './table.css';
import { makeStyles } from '@material-ui/core/styles';
import ReactECharts from 'echarts-for-react';
import { resolveDate } from '../../../../configs/helpers/utility';

const useStyles = makeStyles((theme) => ({
   graphsContainer: {
      width: '100%',
   },
}));

const PDFCSS = () => {
   const classes = useStyles();
   const [filtersData, setFiltersData] = useState();
   const [chartData, setChartData] = useState();
   const [MultiTable, setMultiTable] = useState();
   useEffect(() => {
      let report = localStorage.getItem('report');
      if (report) {
         let { filtersData, chartData, MultiTable } = JSON.parse(report);
         setFiltersData(filtersData);
         setChartData(chartData);
         setMultiTable(MultiTable);
         console.log('MultiTable', MultiTable);
         window.print();
      }
      return () => {
         localStorage.removeItem('report');
      };
   }, []);
   const getChartsOptionsDefault = () => {
      let option = {
         animation: false,
         animationDuration: 0,
         tooltip: {
            trigger: 'axis',
            axisPointer: {
               type: 'cross',
               label: {
                  backgroundColor: '#6a7985',
               },
            },
         },
         legend: {
            data: ['ผู้เข้าใช้งาน'],
         },
         grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
         },
         xAxis: [
            {
               name: 'วัน',
               type: 'category',
               boundaryGap: false,
               data: null,
               axisLabel: { rotate: 45 },
            },
         ],
         yAxis: [
            {
               name: 'ครั้ง',
               type: 'value',
            },
         ],
         series: [
            {
               smooth: true,
               name: 'ผู้เข้าใช้งาน',
               type: 'line',
               stack: 'Total',
               areaStyle: {},
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
         ],
      };
      return option;
   };
   const mapOptions = (data) => {
      let xAxisDate = data.map((el) => el.dateTimeLabel);
      let activityCount = data.map((el) => el.activityCount);
      let options = getChartsOptionsDefault();
      options.xAxis[0].data = xAxisDate;
      options.series[0].data = activityCount;
      return options;
   };
   const costFormat = (value) => {
      return value && new Intl.NumberFormat().format(value);
   };
   return (
      <div className='book'>
         <div className='page' id='1'>
            <div className='subpage'>
               <div className='title'>ข้อมูลกิจกรรมที่แต่ละหน่วยงานจัดขึ้น</div>
               <div className='sub-title'>ตัวกรอง</div>
               <div>
                  <div>
                     กิจกรรม:&nbsp;
                     {(filtersData &&
                        filtersData.activity &&
                        filtersData.activity.activityNameTh) ||
                        '-'}
                  </div>
                  <div>
                     กลุ่ม:{' '}
                     {(filtersData &&
                        filtersData.group &&
                        filtersData.group.data.shortName) ||
                        '-'}
                  </div>
                  <div>
                     สายงาน:{' '}
                     {(filtersData &&
                        filtersData.field &&
                        filtersData.field.data.shortName) ||
                        '-'}
                  </div>
                  <div>
                     ฝ่าย/ภาค:{' '}
                     {(filtersData &&
                        filtersData.department &&
                        filtersData.department.data.shortName) ||
                        '-'}
                  </div>
                  <div>
                     ส่วน/เขต:{' '}
                     {(filtersData &&
                        filtersData.segment &&
                        filtersData.segment.data.shortName) ||
                        '-'}
                  </div>
                  <div>
                     งาน/สาขา:{' '}
                     {(filtersData &&
                        filtersData.branch &&
                        filtersData.branch.data.shortName) ||
                        '-'}
                  </div>
                  <div>
                     เริ่มต้น:{' '}
                     {(filtersData &&
                        resolveDate(filtersData.startDateString)) ||
                        '-'}
                  </div>
                  <div>
                     สิ้นสุด:{' '}
                     {(filtersData && resolveDate(filtersData.endDateString)) ||
                        '-'}
                  </div>
               </div>
               <div className='sub-title'>กราฟ</div>
               <div className={classes.graphsContainer}>
                  {chartData && (
                     <ReactECharts
                        option={mapOptions(chartData)}
                        style={{ height: 300, width: '100%' }}
                     />
                  )}
               </div>
            </div>
         </div>
         <div className='page' id='2'>
            <div className='subpage'>
               <div style={{ marginTop: '10px' }}>
                  {MultiTable && (
                     <div>
                        <div className='title'>{MultiTable[0].tableName}</div>
                        <table className='leaderboard'>
                           <tr>
                              <th>ลำดับ</th>
                              <th>กิจกรรม</th>
                              <th>ครั้ง</th>
                           </tr>
                           {MultiTable[0].activities.map((item) => (
                              <tr>
                                 <td>{item.seq}</td>
                                 <td>{item.activityNameTh}</td>
                                 <td>{item.participateCount}</td>
                              </tr>
                           ))}
                        </table>
                     </div>
                  )}
               </div>
               <div style={{ marginTop: '10px' }}>
                  {MultiTable && (
                     <div>
                        <div className='title'>{MultiTable[1].tableName}</div>
                        <table className='leaderboard'>
                           <tr>
                              <th>ลำดับ</th>
                              <th>กิจกรรม</th>
                              <th>ครั้ง</th>
                           </tr>
                           {MultiTable[1].activities.map((item) => (
                              <tr>
                                 <td>{item.seq}</td>
                                 <td>{item.activityNameTh}</td>
                                 <td>{item.participateCount}</td>
                              </tr>
                           ))}
                        </table>
                     </div>
                  )}
               </div>
            </div>
         </div>
      </div>
   );
};

export default PDFCSS;
